export const AUTH_CONTEXT_VALUES = {
  isAuthenticated: false,
  isLoading: true,
  user: undefined,
  refetch: () => {},
};